import HistoryContent from './HistoryContent';

export default HistoryContent;